module.exports = __webpack_public_path__ + "img/QuotationPriceHistories.54e37a91.svg";